import React, { useEffect } from "react";
import MobileProfileTopNavigation from "../../Pages/MobileProfileLayout/MobileProfileTopNavigation";
import { CgProfile } from "react-icons/cg";
import { settingsLinks } from "../../PageComponentData/Profile/ProfilePage";
import MobileProfileMenuIcon from "./MobileProfileMenuIcon";
import { FaUser } from "react-icons/fa6";

export default function MobileProfileMenuPage({ loggedInUser, handelSlider }) {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    let settingsLinkBlockSmallDevice;
    settingsLinkBlockSmallDevice = settingsLinks?.map((data, i) => {
        return (
            <MobileProfileMenuIcon
                data={data}
                index={i}
                handelSlider={() => { handelSlider() }}
            />
        );
    });
    return (
        <section className="mx-auto grid pb-[25%] grid-cols-1 bg-white rounded-3xl min-h-screen  relative overflow-x-hidden p-6 lg:container lg:grid-cols-3 pt-10">
            <MobileProfileTopNavigation pageTitle={"Profile"} />
            <div className="flex flex-col gap-4 justify-center items-center w-full ms-0 mt-[14%] md:mt-[5%] mb-5">
                <div className="size-20 bg-white rounded-full">
                    {loggedInUser?.data?.hospitalProfile?.profilePic ? (
                        <img
                            src={`${process.env.REACT_APP_API_URL}/${loggedInUser?.data?.hospitalProfile?.profilePic}`}
                            className="w-full h-full rounded-full object-cover"
                        />
                    ) : (
                        // <div className="w-full h-full bg-white flex items-center justify-center rounded-full shadow-sm border ">
                        //     <CgProfile size={40} className="text-lightcolor" />
                        // </div>
                        <div className="w-full h-full bg-gray-200 rounded-full flex items-center justify-center">
                            <FaUser className="text-gray-400 text-base" size={30} />
                        </div>
                    )}
                </div>
                <h2 className="text-coalBlack baseText !font-medium text-center max-w-[70%] capitalize">
                    {loggedInUser?.data?.userName}
                </h2>
            </div>

            {/* mobile devices links  */}
            <div className="space-y-3 block lg:hidden">
                {settingsLinkBlockSmallDevice}
            </div>
        </section>
    )
}